<!-- @format -->

<template>
    <div class="gst-loyalty-info-chip mt-1">
        <div v-if="showMinMax && pointsInfo.minimum && pointsInfo.maximum">
            <div class="gst-loyalty-info-chip__section--minimum">
                <BonusPointsChip :points="pointsInfo.minimum" />
                <p class="mb-2">{{ lowestTierStatus }}</p>
            </div>
            <div class="gst-loyalty-info-chip__section--maximum">
                <BonusPointsChip :points="pointsInfo.maximum" />
                <p>{{ highestTierStatus }}</p>
            </div>
        </div>
        <BonusPointsChip
            v-else-if="!showMinMax && pointsInfo.actual"
            class="gst-loyalty-info-chip__actual"
            :points="pointsInfo.actual" />
    </div>
</template>

<script>
import BonusPointsChip from '@tenants/aadvantagehotels/app/components/chips/BonusPointsChip.vue';

export default {
    name: 'LoyaltyInfoChip',
    components: {
        BonusPointsChip,
    },
    props: {
        /**
         * @prop {Object} pointsInfo - An object containing loyalty points data.
         * @property {number|null} minimum - The minimum points value (for guest users)
         * @property {number|null} maximum - The maximum points value (for guest users)
         * @property {number|null} actual - The actual points value (for logged in users)
         */
        pointsInfo: {
            type: Object,
            required: true,
        },
        lowestTierStatus: {
            type: String,
            required: false,
            default: null,
        },
        highestTierStatus: {
            type: String,
            required: false,
            default: null,
        },
        showMinMax: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';

.gst-loyalty-info-chip {
    p {
        line-height: 15px;
        margin-bottom: theme-spacing(0);
        font-size: 10px;
        font-weight: font-weight('regular');
        margin-left: theme-spacing(5);
    }

    .gst-loyalty-info-chip__section--minimum {
        color: theme-color('primary');
    }

    .gst-loyalty-info-chip__section--maximum {
        color: theme-color('quaternary');
    }

    .gst-loyalty-info-chip__actual {
        color: theme-color('primary');
    }
}
</style>
